import { VueExtension } from '../../utils/extensions/vue';
import Overlay from './overlay.jsx';
import './overlay.scss';

VueExtension.WithInstall(Overlay);

export default Overlay;
